import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { formatterMoney, preventTypingWhenExceed } from '@utils/money';

@Component({
  selector: 'app-info-edit-input',
  templateUrl: './info-edit-input.component.html',
  styleUrls: ['./info-edit-input.component.scss'],
})
export class InfoEditInputComponent implements OnInit {
  @Input() initValue: number;
  @Output() save = new EventEmitter<string>();
  inputValue = null;
  formatterMoney = formatterMoney;
  preventTypingWhenExceed = preventTypingWhenExceed;

  ngOnInit(): void {
    this.inputValue = this.initValue;
  }

  clear() {
    this.inputValue = null;
  }

  callSave($event: MouseEvent) {
    $event.stopPropagation();
    this.save.emit(this.inputValue);
  }
}
